var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChart48Line = function SvgIconChart48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.399 38.7h-18.8a5.31 5.31 0 0 1-5.3-5.3V14.6a5.3 5.3 0 0 1 5.3-5.3h18.8a5.3 5.3 0 0 1 5.3 5.3v18.8a5.31 5.31 0 0 1-5.3 5.3Zm-18.8-26a1.901 1.901 0 0 0-1.9 1.9v18.8a1.9 1.9 0 0 0 1.9 1.9h18.8a1.9 1.9 0 0 0 1.9-1.9V14.6a1.9 1.9 0 0 0-1.9-1.9h-18.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.699 24h-3.4v8h3.4v-8ZM25.699 16h-3.4v16h3.4V16ZM31.699 22h-3.4v10h3.4V22Z",
    fill: "current"
  })));
};
export default SvgIconChart48Line;